<template>
    <div component="Actors" template="page">
        <div class="bg">
            <v-card class="holder">
                <actors-header @onChange="onChange" />
                <actors-list :filter="filter" />
            </v-card>
        </div>
    </div>
</template>

<script>
import ActorsHeader from '@/components/Actors/ActorsHeader';
import ActorsList from '@/components/Actors/ActorsList.vue';

export default {
    name: 'Contract',

    components: {
        ActorsHeader,
        ActorsList,
    },

    data() {
        return {
            loading: true,
            showProject: false,
            filter: {},
        };
    },

    mounted() {},

    methods: {
        onChange(filter) {
            this.filter = filter;
        },
    },

    computed: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Actors'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }
}
</style>
